





































import { Component, Vue } from "vue-property-decorator";
import router, { resetRouter } from "@/router";
import getAsyncRouter from "@/router/async-router";
import { addRoutes } from "@/utils";

@Component
export default class PermissionDirective extends Vue {
  key = 0;
  roles: [string, string] = ["admin", "user"];
  checkList: [] = this.$store.getters.roles;

  async handleCheckedChange(roles: []): Promise<unknown> {
      await this.$store.dispatch("user/SetRoles", roles);
      this.key++;
      resetRouter();
      const res = await this.$store.dispatch("permission/GenerateRoutes", roles);
      return addRoutes(router, getAsyncRouter(res));
  }
}
